//EntityList.jsx 
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import Tooltip from '../../components/utils/Tooltip';

const EntityList = () => {
  const location = useLocation();
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();

  const [entities, setEntities] = useState([]);
  const [activeStatus, setActiveStatus] = useState(true);

  const [param1, setParam1] = useState('active');
  const [param2, setParam2] = useState('true');

  const [fetchData, { loading }] = useFetch();
  const [selectedEntityId, setSelectedEntityId] = useState(null);
  const [hoveredButton, setHoveredButton] = useState(null);


  const fetchEntities = useCallback(() => {
    const config = {
      url: "/entitymaster/list",
      method: "post",
      headers: { Authorization: authState.token },
      data: { searchFor: param1, searchCriteria: param2 },
    };

    fetchData(config, { showSuccessToast: false })
      .then(data => {
        if (data && Array.isArray(data)) {
          setEntities(data);
        } else {
          console.error("Invalid response format: Entities not found in response!");
        }
      })
      .catch(error => {
        console.error('Error fetching Entities:', error);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchEntities();
  }, [authState.isLoggedIn, fetchEntities]);

  const handleView = (entityId) => {
    setSelectedEntityId(prevId => (prevId === entityId ? null : entityId));
  };

  const formatDateTime = (date) => {
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };
  
  const sortedEntities = [...entities].sort((a, b) => b.entityName - a.entityName);

  const handleHover = (buttonId) => {
    setHoveredButton(buttonId);
  };

  const handleBlur = () => {
    setHoveredButton(null);
  };

  const setSearch = (p1, p2) => {
    setParam1(p1);
    setParam2(p2);
    fetchEntities();
  };

  useEffect(() => {
    // 
  }, [param1, param2]);

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Entities - List</h2>
      </div>
      <div className="my-2 mx-auto max-w-[700px] py-4">
        <div className="border border-gray-300 p-4 mt-4">
          <div className="button-row">
            <button
              id='active'
              className={`button-style`}
              style={{
                backgroundColor: hoveredButton === 'active' ? '#666' : '#00ff00',
                color: hoveredButton === 'active' ? '#fff' : '#333'
              }}
              onClick={() => setSearch('active', 'true')}
              onMouseEnter={() => handleHover('active')}
              onMouseLeave={handleBlur}
              onFocus={() => handleHover('active')}
              onBlur={handleBlur}
            >
              Active
            </button>

            <button
              id='inactive'
              className={`button-style`}
              style={{
                backgroundColor: hoveredButton === 'inactive' ? '#666' : '#00ff00',
                color: hoveredButton === 'inactive' ? '#fff' : '#333'
              }}
              onClick={() => setSearch('inactive', 'false')}
              onMouseEnter={() => handleHover('inactive')}
              onMouseLeave={handleBlur}
              onFocus={() => handleHover('inactive')}
              onBlur={handleBlur}
            >
              InActive
            </button>

            <button
              id='today'
              className={`button-style`}
              style={{
                backgroundColor: hoveredButton === 'today' ? '#666' : '#00ff00',
                color: hoveredButton === 'today' ? '#fff' : '#333'
              }}
              onClick={() => setSearch('today', 'today')}
              onMouseEnter={() => handleHover('today')}
              onMouseLeave={handleBlur}
              onFocus={() => handleHover('today')}
              onBlur={handleBlur}
            >
              Today
            </button>
            <button
              id='mtd'
              className={`button-style`}
              style={{
                backgroundColor: hoveredButton === 'mtd' ? '#666' : '#00ff00',
                color: hoveredButton === 'mtd' ? '#fff' : '#333'
              }}
              onClick={() => setSearch('mtd', 'mtd')}
              onMouseEnter={() => handleHover('mtd')}
              onMouseLeave={handleBlur}
              onFocus={() => handleHover('mtd')}
              onBlur={handleBlur}
            >
              MTD
            </button>
          </div>
          <div className="flex justify-between items-center border-b border-b-gray-300 bg-purple-600">
            <div className='text-xl mt-1 mx-2  text-white w-7/10'>
              <p className='text-yellow-300' >There are {entities.length} Records for {param2}</p>
            </div>
          </div>
          {loading ? (
            <div className="spinner-container">
              <div className="spinner">
                <FontAwesomeIcon icon={faSpinner} spin />
              </div>
            </div>
          ) : (
            <div>
              {entities.length === 0 ? (
                <div className='w-[600px] h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
                  <span>No record found!!</span>
                </div>
              ) : (
                sortedEntities.map((entity, index) => (
                  <div key={entity._id} className='bg-white my-1 p-4 text-gray-600 rounded-md shadow-md'>
                    <div className='flex items-center h-2'>
                      <span className='font-medium'>{index + 1}. {entity.entityName}</span>
                      <Tooltip text={"Club Details"} position={"top"}>
                        <span className='ml-auto mr-2 text-blue-500 cursor-pointer' onClick={() => handleView(entity._id)}>
                          <i className="fa-solid fa-eye"></i>
                        </span>
                      </Tooltip>
                    </div>
                    {selectedEntityId === entity._id && (
                      <div className='bg-gray-200 text-black mt-2'>
                        <div>
                          <div>
                            <p><strong>Entity Info</strong></p>
                            <p><strong>Name:</strong> {entity.entityName}</p>
                            <p><strong>Type:</strong> {entity.entityType}</p>
                            <p><strong>SubType:</strong> {entity.entitySubType}</p>
                            <p><strong>Address:</strong> {entity.entityAddress}</p>
                            <p><strong>Contact#:</strong> {entity.entityContact}</p>
                            <p><strong>Email:</strong> {entity.entityEmail}</p>
                            <p><strong>Remarks:</strong> {entity.remarks}</p>
                            <p><strong>Active Status:</strong> {entity.isActive ? "Active" : "InActive"}</p>
                            <p><strong>Registration Date:</strong>{new Date(entity.dateCreated).toLocaleString()}</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    </MainLayout>
  )
}

export default EntityList;
